<script setup>
import { defineAsyncComponent, ref } from "vue";
import PcUserLoadingShell from "@variants/seer/user/pc/components/page-skeleton/LoadingShell.vue";

const { $isMobile } = useNuxtApp();

definePageMeta({
	ssr: false,
	"m-showNavBar": true,
	"m-showFooter": true,
	"pc-showNavBar": true,
	"pc-showFooter": true,
	breadcrumbName: "common.breadcrumb.userCenter",
});

useHead({
	title: "先知命局，陪你找到人生方向",
	meta: [
		{ name: "keywords", content: "八字算命，八字排盤，名字算命" },
		{
			name: "description",
			content:
				"先知命局是一個面向全球的命理文化平台，專注於八字算命與八字排盤服務，讓您了解自己命格的深層意義。專業分析將幫助您預測未來運勢，提供事業、健康、財富等方面的指引，助您順利度過人生每個階段。",
		},
	],
});

const isMobile = Boolean($isMobile);
const pcContentReady = ref(false);

// 不用 loadingComponent：避免「骨架卸载 → 真页面挂载」中间空一帧被压扁
const Component = isMobile
	? defineAsyncComponent(() => import("@variants/seer/user/m/index.vue"))
	: defineAsyncComponent(() => import("@variants/seer/user/pc/index.vue"));

const onPcContentReady = () => {
	pcContentReady.value = true;
};
</script>

<template>
	<ClientOnly>
		<template v-if="!isMobile">
			<div class="pc-user-entry">
				<Component @content-ready="onPcContentReady" />
				<!-- 盖在真内容上，就绪后再撤，避免切换闪压扁 -->
				<div v-if="!pcContentReady" class="pc-user-entry__cover" aria-hidden="true">
					<PcUserLoadingShell />
				</div>
			</div>
		</template>
		<Component v-else />
		<template #fallback>
			<div v-if="!isMobile" class="pc-user-entry">
				<PcUserLoadingShell />
			</div>
		</template>
	</ClientOnly>
</template>

<style lang="scss" scoped>
.pc-user-entry {
	position: relative;
	min-height: 780px;
	background: #ffffff;
}

.pc-user-entry__cover {
	position: absolute;
	inset: 0;
	z-index: 20;
	background: #ffffff;
}
</style>
